import jQuery from "jquery";

export default () => {

    jQuery(document).ready(function ($) {

        // share box
        const $shareDropdown = $('.share-open');
        $(document).mouseup(e => {
            if (!$shareDropdown.is(e.target) && $shareDropdown.has(e.target).length === 0) {
                $shareDropdown.removeClass('show');
            }
        });

        let dropdown = document.querySelectorAll('.share-dropdown'),
            dropdownArray = Array.prototype.slice.call(dropdown, 0);

        dropdownArray.forEach(function (el) {
            let button = el.querySelector('a[data-toggle="share-dropdown"]'),
                menu = el.querySelector('.share-dropdown-menu'),
                arrow = button.querySelector('i.share-icon'),
                close = el.querySelector('span.close-share'),
                fbShare = 'https://www.facebook.com/sharer/sharer.php?u=',
                twitterShare = 'https://twitter.com/intent/tweet?url=',
                parentBlock = el.closest('.post');

            if (!document.querySelector('body').classList.contains('single')) {
                let url = parentBlock.querySelector('.post__title a').getAttribute('href');
                let title = parentBlock.querySelector('.post__title a');
                let author = parentBlock.querySelector('.post__byline a');

                parentBlock.querySelector('.share-twitter').setAttribute('href', `${twitterShare}${url}&text=${title}&via=${author}`);
                parentBlock.querySelector('.share-facebook').setAttribute('href', `${fbShare}${url}`);
            }

            button.onclick = function (event) {
                if (!menu.hasClass('show')) {
                    menu.classList.add('show');
                    menu.classList.remove('hide');
                    arrow.classList.add('open');
                    arrow.classList.remove('close');
                    event.preventDefault();
                }
            };
            close.onclick = function (event) {
                if (!menu.hasClass('hide')) {
                    menu.classList.remove('show');
                    menu.classList.add('hide');
                    arrow.classList.remove('open');
                    arrow.classList.add('close');
                    event.preventDefault();
                }
            }
        });

        Element.prototype.hasClass = function (className) {
            return this.className && new RegExp("(^|\\s)" + className + "(\\s|$)").test(this.className);
        };

        // Copy link to clipboard
        let copyTextareaBtn = document.querySelector('.shareBtn');
        let copyTextareaBtn1 = document.querySelector('.copy-link');
        let copyUrl = document.querySelector('.shareBtnCopy');

        copyTextareaBtn && copyTextareaBtn.addEventListener('click', function () {
            let copyTextarea = document.querySelector('.copy-url');
            copyTextarea.focus();
            copyTextarea.select();

            try {
                let successful = document.execCommand('copy');
                let msg = successful ? 'Copied' : 'No copied';
                copyTextareaBtn1.innerHTML = msg;
            } catch (err) {

            }
        });

        copyUrl && document.querySelectorAll('.shareBtnCopy').forEach(item => {
            item.addEventListener('click', e => {
                let isSingle = document.querySelector('body').classList.contains('single');
                let copyPostUrl = e.target.closest('.post');
                let copyTextareaBtn1 = copyPostUrl.querySelector('.copy-link');
                let copiedUrl = !isSingle && copyPostUrl.querySelector('.post__title a').getAttribute('href');
                let copyTextarea = copyPostUrl.querySelector('.copy-url');
                if (!isSingle) {
                    copyTextarea.value = copiedUrl;
                }
                copyTextarea.focus();
                copyTextarea.select();
                try {
                    let successful = document.execCommand('copy');
                    let msg = successful ? 'Copied' : 'No copied';
                    copyTextareaBtn1.innerHTML = msg;
                } catch (err) {

                }
            })
        });


        $(window).scroll(function () {
            let scrollShare = parseInt($(window).scrollTop());
            if (scrollShare >= 150) {
                $('.sharing-box').addClass('fixed-height');
            } else if (scrollShare <= 149) {
                $('.sharing-box').removeClass('fixed-height');
            }
        });

    });
}